export const extractDataFromUrl = (link: string | null) => {
  let wordFromUrl = null;
  let idFromUrl = null;
  let resultWordFromUrl = null;

  if (link) {
    const regex =
      /https?:\/\/(localhost:3001|odkb-soyuz\.org)\/([a-zA-Z]+)\/(\d+)/;
    const match = link.match(regex);

    if (match) {
      wordFromUrl = match[2]; // Здесь теперь будет "analitics"
      idFromUrl = match[3]; // Здесь будет "591"
    }
  }

  switch (wordFromUrl) {
    case 'analitics':
      resultWordFromUrl = 'analitikas';
      break;
    case 'intervyus':
      resultWordFromUrl = 'intervyus';
      break;
    case 'pobeda':
      resultWordFromUrl = 'pobedas';
      break;
    case 'favorites':
      resultWordFromUrl = 'izbrannyes';
      break;
    default:
      resultWordFromUrl = null; // or you can return another default value
  }

  return { wordFromUrl, idFromUrl, resultWordFromUrl };
};
